import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { listSelector } from "@/pages/Private/redux/list/list.slice";
import { useAppSelector } from "@/redux/hooks";

/**
 * The Messages surfaces' load-failure notice (PREC-5088). A rejected `getAllProspects` used to
 * leave an empty inbox on screen — indistinguishable from a list that genuinely has no leads.
 * This says the leads could not be loaded instead. Reads the request-level `inboxLoadFailed`
 * flag and renders nothing unless the latest request failed.
 */
export const MessagesLoadError: FunctionComponent = () => {
	const { t } = useTranslation("translation", { keyPrefix: "inbox.thread.loadError" });
	const { inboxLoadFailed } = useAppSelector(listSelector);

	if (!inboxLoadFailed) {
		return null;
	}

	return (
		<div
			className="flex flex-col items-center gap-2 px-6 py-10 text-center"
			data-test="messages-load-error"
			role="alert"
		>
			<p className="text-sm font-medium text-status-error">{t("title")}</p>
			<p className="text-xs text-text-meta">{t("hint")}</p>
		</div>
	);
};
